export const UI_DOCUMENT_PANEL_DIALOG_CONFIG = {
  width: '95vw',
  height: '95vh',
  maxWidth: '95vw',
  maxHeight: '95vh',
  panelClass: 'ui-document-panel',
  disableClose: true,
} as const;

export const UI_DOCUMENT_PANEL_BREADCRUMBS = {
  requisition: 'Procurement / Requisitions',
  purchaseOrder: 'Procurement / Purchase Orders',
  grn: 'Procurement / GSRN',
  qualityCheck: 'Procurement / Quality Check',
  salesOrder: 'Sales / Sales Orders',
  gsn: 'Sales / GSSN',
  salesVoucher: 'Finance / Sales Voucher',
  purchaseVoucher: 'Finance / Purchase Voucher',
  salesReturn: 'Sales / Sales Return',
  purchaseReturn: 'Procurement / Purchase Return',
  creditNoteVoucher: 'Finance / Credit Note',
  debitNoteVoucher: 'Finance / Debit Note',
} as const;
